import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import AppRoutes from "./routes/AppRoutes";
import FootPrintModal from "./components/common/FootPrintModal";
import PolicyModal from "./components/common/PolicyModal";
import { useRequestProcessor } from "./requestProcessor";
import { fetchConstants } from "./queryfunctions/queryfunctions";
import FootprintNotification from "./components/common/FootprintNotification";
import { sendUnsentReports, setEnabled } from "./crashlyticsMethods";


const App = () => {
    const { useQueryWrapper } = useRequestProcessor()

    useQueryWrapper(
        ["fetchConstants"],
        () => fetchConstants()
    );

    // Initialize Crashlytics and send unsent reports as early as possible
    useEffect(() => {
        if (!Capacitor.isNativePlatform()) return;

        (async () => {
            try {
                // Enable crashlytics first
                await setEnabled(true);
                // Then send any unsent crash reports from previous sessions
                await sendUnsentReports();
            } catch (e) {
                console.warn("Crashlytics initialization failed", e);
            }
        })();
    }, []);

    return (
        <Router>
            <FootPrintModal />
            <FootprintNotification />
            <PolicyModal />
            <AppRoutes />
        </Router>
    );
};

export default App;
